import { useMemo } from 'react';

import { Job, JobMatch, JobMatchStageEnum } from '@libs/graphql-types';

/**
 * Returns an object where keys are JobMatchStageEnum values and values are arrays of JobMatch for that stage.
 */
export function useJobMatchesByStage(jobData: Job | undefined | null) {
  return useMemo(() => {
    const result: Partial<Record<JobMatchStageEnum, JobMatch[]>> = {};
    if (!jobData?.matches) return result;
    for (const match of jobData.matches) {
      if (!match) continue;
      const stage =
        (match.stage as JobMatchStageEnum) || JobMatchStageEnum.InstantMatch;
      if (!result[stage]) {
        result[stage] = [];
      }
      result[stage]!.push(match);
    }
    return result;
  }, [jobData]);
}

/**
 * Returns the tab info array for the ATS tabs, using the matchesByStage object.
 */
export function useJobMatchTabs(
  matchesByStage: Partial<Record<JobMatchStageEnum, JobMatch[]>>,
) {
  return useMemo(
    () => [
      {
        id: JobMatchStageEnum.InstantMatch,
        label: 'INSTANT MATCHES',
        count: matchesByStage[JobMatchStageEnum.InstantMatch]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Application,
        label: 'APPLICATION',
        count: matchesByStage[JobMatchStageEnum.Application]?.length || 0,
      },
      {
        id: JobMatchStageEnum.InternalInterview,
        label: 'INTERNAL INTERVIEW',
        count: matchesByStage[JobMatchStageEnum.InternalInterview]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Submittal,
        label: 'SUBMITTAL',
        count: matchesByStage[JobMatchStageEnum.Submittal]?.length || 0,
      },
      {
        id: JobMatchStageEnum.ShortList,
        label: 'SHORTLIST',
        count: matchesByStage[JobMatchStageEnum.ShortList]?.length || 0,
      },
      {
        id: JobMatchStageEnum.ClientInterview,
        label: 'CLIENT INTERVIEW',
        count: matchesByStage[JobMatchStageEnum.ClientInterview]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Offer,
        label: 'OFFER',
        count: matchesByStage[JobMatchStageEnum.Offer]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Onboarding,
        label: 'ONBOARDING',
        count: matchesByStage[JobMatchStageEnum.Onboarding]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Rejected,
        label: 'REJECTED',
        count: matchesByStage[JobMatchStageEnum.Rejected]?.length || 0,
      },
      {
        id: JobMatchStageEnum.Placement,
        label: 'PLACEMENT',
        count: matchesByStage[JobMatchStageEnum.Placement]?.length || 0,
      },
    ],
    [matchesByStage],
  );
}
